import React from 'react';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';
import buildRecordViewerPath from '../../util/buildRecordViewerPath';

const defaultSchema = require('hast-util-sanitize/lib/github.json');

export const MAX_CONTENT_LENGTH = 10_000;
export const MAX_ATTACHMENT_SIZE = 20 * 1024 * 1024;
export const ALLOWED_ATTACHMENT_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/webp',
  'text/plain',
];

export const EMPTY_PROMPT_CHIPS = [
  'Summarize this patient document in plain language.',
  'Draft a prior authorization request from this note.',
  'Extract key follow-up tasks from this message.',
  'Create a concise referral summary with next steps.',
];

export const remarkPlugins = [remarkGfm];
export const aiChatSanitizeSchema = {
  ...defaultSchema,
  tagNames: defaultSchema.tagNames.filter((tagName) => tagName !== 'img'),
};
export const rehypePlugins = [[rehypeSanitize, aiChatSanitizeSchema]];

export const markdownComponents = {
  a: ({ children, href }) => {
    const safeHref = /^https?:\/\/|^mailto:/i.test(href) ? href : undefined;
    return (
      <a href={safeHref} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  },
};

export const formatMessageTime = (timestamp) => {
  if (!timestamp) return '';
  const value = new Date(timestamp);
  if (Number.isNaN(value.getTime())) return '';
  return value.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

export const formatFileSize = (byteSize) => {
  if (!byteSize || byteSize < 1024) return `${byteSize || 0} B`;
  if (byteSize < 1024 * 1024) return `${(byteSize / 1024).toFixed(1)} KB`;
  return `${(byteSize / (1024 * 1024)).toFixed(1)} MB`;
};

// The in-app link a document chat stores so the user can get back to the record.
export const documentViewerPath = (selectedRecordDetails, fileToken) => {
  // The full-page viewer has no inbox row selected (details are `{}`).
  if (!selectedRecordDetails?.file_token) return `/app/view/${fileToken}`;

  let mode = window.location.pathname.split('/')[2] || 'received';
  if (mode === 'uploads') {
    mode = 'uploaded';
  }
  return buildRecordViewerPath(selectedRecordDetails, { mode });
};

export const DOCUMENT_FALLBACK_TITLE = 'Untitled document';
